"use client";
import CourseCard from "@/components/shared/CourseCard";
import CustomInput from "@/components/shared/CustomInput";
import { Form, Formik } from "formik";
import React, { useState, useEffect } from "react";
import search from "@/public/images/search.svg";
import Image from "next/image";

interface Props {
  teacher?: any;
  courses: any;
}

const courseTypes = [
  { id: 0, name: "كورسات الحصه" },
  { id: 1, name: "كورسات الشهر" },
  { id: 2, name: "كورسات السنه" },
];

const Index: React.FC<Props> = ({ teacher, courses }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSchoolYears, setSelectedSchoolYears] = useState<any[]>([]);
  const [selectedCourseTypes, setSelectedCourseTypes] = useState<number[]>([]);
  const [filteredCourses, setFilteredCourses] = useState(courses);

  useEffect(() => {
    if (teacher && teacher.school_years) {
      setSelectedSchoolYears(teacher.school_years);
    }
  }, [teacher]);

  useEffect(() => {
    filterCourses();
  }, [searchTerm, selectedSchoolYears, selectedCourseTypes, courses]);

  const toggleSchoolYear = (schoolYear: any) => {
    setSelectedSchoolYears((prevSelected) =>
      prevSelected.includes(schoolYear)
        ? prevSelected.filter((sy) => sy.id !== schoolYear.id)
        : [...prevSelected, schoolYear]
    );
  };

  const toggleCourseType = (courseTypeId: number) => {
    setSelectedCourseTypes((prevSelected) =>
      prevSelected.includes(courseTypeId)
        ? prevSelected.filter((id) => id !== courseTypeId)
        : [...prevSelected, courseTypeId]
    );
  };

  const filterCourses = () => {
    let updatedCourses = courses;

    if (searchTerm) {
      updatedCourses = updatedCourses.filter((course: any) =>
        course.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (selectedSchoolYears.length > 0) {
      const selectedSchoolYearIds = selectedSchoolYears.map((sy) => sy.id);
      updatedCourses = updatedCourses.filter((course: any) =>
        course.school_years.some((sy: any) =>
          selectedSchoolYearIds.includes(sy.id)
        )
      );
    }

    if (selectedCourseTypes.length > 0) {
      updatedCourses = updatedCourses.filter((course: any) =>
        selectedCourseTypes.includes(course.type)
      );
    }

    setFilteredCourses(updatedCourses);
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div className="flex gap-3 flex-wrap">
          {teacher &&
            teacher.school_years &&
            teacher.school_years.map((item: any) => (
              <p
                key={item.id}
                className={`text-14 h-[60px] py-[5px] px-[15px] rounded-[10px] flex grow items-center justify-center cursor-pointer ${selectedSchoolYears.includes(item)
                  ? "bg-primaryColor text-[#ffffff]"
                  : "text-textColor bg-[#695750]"
                  }`}
                onClick={() => toggleSchoolYear(item)}
              >
                {item.name}
              </p>
            ))}
        </div>
        <div className="flex items-center bg-[#695750] rounded-[10px] h-[60px] py-2 pl-3">
          <Formik
            initialValues={{ search: "" }}
            onSubmit={(values) => setSearchTerm(values.search)}
          >
            {({ handleChange, handleBlur, handleSubmit }) => (
              <Form
                className="w-full"
                onSubmit={handleSubmit}
              >
                <CustomInput
                  type="text"
                  name="search"
                  placeholder="بحث عن مدرس في المنصة"
                />
              </Form>
            )}
          </Formik>
          <button type="submit">
            <Image
              src={search}
              alt="search"
            />
          </button>
        </div>
      </div>
      <div className="flex gap-3 flex-wrap">
        {courseTypes.map((type) => (
          <p
            key={type.id}
            className={`text-14 h-[60px] py-[5px] px-[15px] rounded-[10px] flex grow items-center justify-center cursor-pointer ${selectedCourseTypes.includes(type.id)
              ? "bg-primaryColor text-[#ffffff]"
              : "text-textColor bg-[#695750]"
              }`}
            onClick={() => toggleCourseType(type.id)}
          >
            {type.name}
          </p>
        ))}
      </div>
      {filteredCourses.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 place-content-center place-items-center">
          {filteredCourses.map((item: any, i: number) => (
            <CourseCard
              key={i}
              course={item}
            />
          ))}
        </div>
      ) : (
        <div className="text-center text-red-400 bg-[#695750] rounded-[5px] py-5 px-3">
          <p>لم يتم العثور على دورات بناءً على الفلاتر المطبقة.</p>
        </div>
      )}
    </>
  );
};

export default Index;
